import type { FaireProductEntity } from "../../entity_types/product";

export const p_3hpjgknyfk: FaireProductEntity = {
  token: "p_3hpjgknyfk",
  type: "product",
  name: "Leaf Teak Wood Plate",
  brandName: "Rainforest Bowls",
  imageUrl:
    "https://cdn.faire.com/fastly/e0a4a207c537c9bd3bd752c53bab0d4eac0d367109445502b128570b290865bd.jpeg",
  priceDollars: 6.75,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/014490c47bb5fc0e93149a1905367b31769d4b9be0894fb8e3b281e198d96ef5.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
